var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertBloodPressure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8F3052E0-0001-4962-B655-B266EE3CBACC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-215.000000, -798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom",
    transform: "translate(216.000000, 799.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#FF335C",
    cx: 16,
    cy: 16,
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4997623,11 L20.4664411,16.6027344 C20.8344966,17.2327356 21.01887,17.9546458 20.9984737,18.6855029 C20.9745051,19.3890546 20.7782627,20.075642 20.4272618,20.6841473 C19.6132532,22.1126302 18.1084203,23 16.4998775,23 C14.894446,23 13.3912264,22.1144893 12.5768721,20.6892598 C12.223797,20.0784306 12.0261717,19.3890546 12.001627,18.6825981 C11.9828824,18.0291258 12.1263864,17.3826309 12.4174902,16.8013804 L12.5335443,16.5865835 L16.4997623,11 Z M19.3482389,18 C18.9882873,18 18.6964774,18.291821 18.6964774,18.651771 C18.6951408,19.780348 17.780268,20.6952241 16.6513242,20.6964582 C16.2918098,20.6964579 16,20.9882789 16,21.348229 C16,21.708179 16.2918098,22 16.6517614,22 C18.5002197,21.9980455 19.9979062,20.5003447 20,18.6522242 C20,18.291821 19.7081905,18 19.3482389,18 Z M19.6496197,10 L23.4857199,14.8571714 C24.0738944,15.7757384 24.1606584,16.8376953 23.7300109,17.8486553 C23.3241926,18.7891672 22.5415234,19.5571128 21.5378748,20 C21.7165066,19.5301804 21.8158231,19.0386654 21.8323759,18.5420381 C21.8602397,17.6586327 21.6107069,16.7861997 21.1124691,16.0257354 C21.108055,16.0190023 21.1033651,16.0123939 21.0983993,16.0060348 L21.0983993,16.0060348 L18,12.0830164 L19.6496197,10 Z M13.3503803,10 L15,12.0830164 L11.9016007,16.0060348 C11.8966349,16.0123939 11.891945,16.0190023 11.8875309,16.0257354 C11.3892931,16.7861997 11.1397603,17.6586327 11.1676241,18.5420381 C11.1841769,19.0386654 11.2834934,19.5301804 11.4621252,20 C10.4584766,19.5571128 9.67580738,18.7891672 9.26998906,17.8486553 C8.83934165,16.8376953 8.92610565,15.7757384 9.5142801,14.8571714 L13.3503803,10 Z",
    id: "Combined-Shape",
    fill: "#FF335C",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertBloodPressure);
export default __webpack_public_path__ + "static/media/avatar-alert-blood-pressure.9c43fef81912687439837e0adbcfca46.svg";
export { ForwardRef as ReactComponent };